import React from 'react'
import styled from 'styled-components'
import tinycolor from 'tinycolor2'
import {
  Button as ReactstrapButton
} from 'reactstrap'

import {
  makeTranslationAware
} from '../../../utils'

const StyledReactstrapButton = styled(ReactstrapButton)`
  background-color: ${({ theme }) => theme.colors.main } !important;
  border-color: ${({ theme }) => theme.colors.main } !important;
  border-radius: 3200px !important;
  color: ${({ theme }) => theme.colors.text.main } !important;
  padding-left: 2rem !important;
  padding-right: 2rem !important;

  &:hover {
    background-color: ${({ theme }) => (
      tinycolor(theme.colors.main).darken(10).toString()
    )} !important;
  }
`

export const RawButton = ({ children, href, ...props }) => {
  return (
    <div>
      <StyledReactstrapButton
        href={ href }
        tag={ href ? 'a' : 'button' }
        size="lg"
        { ...props }
      >
        { children }
      </StyledReactstrapButton>
    </div>
  )
}

const TranslatedButton = makeTranslationAware(RawButton)
TranslatedButton.displayName = 'TranslatedButton'

export default TranslatedButton



// WEBPACK FOOTER //
// ./src/components/atoms/Button/Button.js